import React, { useEffect } from "react";

// Importing bootstrap components
import { Form, Button, Table } from "react-bootstrap";

// Importing common components
import WarningAlert from "common/Alert";

import { batch, useDispatch, useSelector } from "react-redux";

import {
  setShifts,
  setIsDefaultSet,
} from "state/slices/shift/shiftSlice";

// Importing shift mutations
import { useGetShiftsQuery } from "state/slices/shift/shiftApiSlice";

const ShiftViewManagement = ({
  isAllowedToUpdate = false,
  isAllowedToDelete = false,
  handleCheckboxChange = () => {},
  handleEdit = () => {},
  deleteShiftManage = () => {},
  selectedRow = null,
}) => {
  const dispatch = useDispatch();

  // Fetch shifts
  const { data, refetch, isLoading } = useGetShiftsQuery();

  const shifts = useSelector((state) => state.shift.shifts);
  const isDefaultSet = useSelector((state) => state.shift.isDefaultSet);

  useEffect(() => {
    if (data) {
      batch(() => {
        dispatch(setShifts(data.shifts));
        dispatch(setIsDefaultSet(data.isDefaultSet));
      });
    }
  }, [data]);

  useEffect(() => {
    refetch();
  }, [shifts]);

  return (
    <>
      {!isDefaultSet && shifts.length > 0 && (
        <WarningAlert 
          icon={<i className="bi bi-exclamation-triangle-fill me-2"></i>}
          message="Warning: No default shift is set. Please set it to prevent rendering wrong data." 
        />
      )}
      <Table striped responsive bordered className="text-center">
        <thead>
          <tr>
            {(isAllowedToUpdate || isAllowedToDelete) && <th></th>}
            <th>S No.</th>
            <th>Shift</th>
            <th>Start Time</th>
            <th>End Time</th>
            {(isAllowedToUpdate || isAllowedToDelete) && <th>Action</th>}
          </tr>
        </thead>
        <tbody>
          {shifts.length > 0 ? (
            shifts?.map((row, index) => (
              <tr key={row.id} id={row?.isDefault ? "default" : ""}>
                {(isAllowedToUpdate || isAllowedToDelete) && (
                  <td className="text-center">
                    <Form.Check
                      type="checkbox"
                      name="row"
                      value={row.id}
                      checked={selectedRow?.id === row.id}
                      onChange={(e) => handleCheckboxChange(e, row)}
                    />
                  </td>
                )}
                <td>{index + 1}</td>
                <td>{row.name}</td>
                <td>{row.startTime}</td>
                <td>{row.endTime}</td>

                {(isAllowedToUpdate || isAllowedToDelete) && (
                  <td>
                    {isAllowedToUpdate && (
                      <Button
                        size="sm"
                        variant="outline-primary"
                        className="me-2"
                        disabled={!selectedRow || selectedRow?.id !== row.id}
                        onClick={() => handleEdit(row)}
                      >
                        <i className="bi bi-pencil-square"></i>
                      </Button>
                    )}
                    {isAllowedToDelete && (
                      <Button
                        size="sm"
                        variant="outline-danger"
                        disabled={!selectedRow || selectedRow?.id !== row.id}
                        onClick={deleteShiftManage}
                      >
                        <i className="bi bi-trash3"></i>
                      </Button>
                    )}
                  </td>
                )}
              </tr>
            ))
          ) : (
            <tr className="bg-light border text-center">
              <td colSpan={6} className="text-muted">
                {isLoading ? "Loading Data..." : "No Data Found"}
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </>
  );
};

export default ShiftViewManagement;
